import styled from '@emotion/styled'
import copy from 'copy-to-clipboard'
import Button from './Button'
import Input from './Input2'

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  border-color: ${({ theme }) => theme.colors.lightGray};
  border-radius: 0.125rem;
  border-width: 1px;
  box-shadow: 0 0.375rem 1.9375rem 0 rgba(0, 0, 0, 0.2);
  left: 1rem;
  max-width: 16rem;
  padding: 1rem;
  position: absolute;
  top: 1.5rem;
  z-index: 999;
`

const PopOver = ({ onBlur, onCopy, slug }) => {
  const code = `<iframe src="https://www.buymusic.club/embed/${slug}" height="500" width="100%" frameborder="0"></iframe>`

  const handleBlur = (e) => {
    handleCopy()
    onBlur()
  }

  const handleCopy = () => {
    copy(code)
    onCopy()
  }

  return (
    <Container>
      <Input
        autoFocus
        className="mb2"
        label="Copy and paste this HTML code to your website"
        onBlur={handleBlur}
        onChange={() => {}}
        type="text"
        value={code}
      />

      <Button small onClick={handleCopy}>
        Copy to clipboard
      </Button>
    </Container>
  )
}

export default PopOver
